import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useAuthentication } from "@libs/acp/contexts/Authentication";
import { useRedline } from "@libs/redline";

import constants from "@shared/constants";
import PageLoader from "@shared/ui/PageLoader";

export default function PublicRoutes() {
	const { isLoading } = useAuthentication();
	const { createCorrelationId } = useRedline();

	useEffect(() => {
		createCorrelationId(constants.redline.RL_TRACK_CID);
	}, []);

	if (isLoading) return <PageLoader />;

	return (
		<>
			<Outlet />
		</>
	);
}
